export const ROUTE_PLAYBACK_SPEEDS=[.5,1,5,10,50,100,200,500];
/** 1× follows recorded time. Only unobserved gaps are shortened. */
export function routePlaybackStep(points,index,speed=1){
 if(!Number.isInteger(index)||index<0||index>=points.length-1)return null;
 const multiplier=ROUTE_PLAYBACK_SPEEDS.includes(speed)?speed:1,nextIndex=index+1;
 const gap=Date.parse(points[nextIndex].receivedAt)-Date.parse(points[index].receivedAt);
 return {nextIndex,delayMs:points[nextIndex].connectFromPrevious&&Number.isFinite(gap)&&gap>0
  ?gap/multiplier:500/multiplier};
}
// Frame rate and the number of turns must not change the playback clock.
export function advanceRoutePlayback(points,index,fraction,elapsedMs,speed=1){
 if(!Number.isInteger(index)||index<0||index>=points.length)return {index,fraction:0};
 let progress=Math.max(0,Math.min(1,Number(fraction)||0)),remaining=Math.max(0,Number(elapsedMs)||0),step;
 while((step=routePlaybackStep(points,index,speed))){
  const needed=(1-progress)*step.delayMs;
  if(remaining<needed)return {index,fraction:progress+remaining/step.delayMs};
  remaining-=needed;index=step.nextIndex;progress=0;
 }
 return {index,fraction:0};
}
// Geometry enrichment replaces objects but not the recorded route membership.
export function routePlaybackIdentity(deviceId,route){
 return `${deviceId??''}:${route?.startAt??''}:${route?.endAt??''}:${route?.snapshotId??''}`;
}
